import { ReactComponent as Broken } from "../../assets/images/broken.svg";
import { ReactComponent as Whatsapp } from "../../assets/images/Whatsapp.svg";

export const PaymentDown = (
  props: Readonly<{
    problem: string;
    alternative?: string;
    onContact: () => void;
  }>
) => {
  const { problem, alternative, onContact } = props;
  return (
    <div className="h-full w-full flex flex-col bg-background">
      <div className="flex flex-col items-center">
        <div className="flex justify-center p-6">
          <Broken />
        </div>
        <div className="flex flex-col items-center justify-center gap-2">
          <span className="text-primary opacity-70 text-base">
            {`${problem}😞`}
          </span>
          <span className="text-xl font-semibold">Contact Support</span>
        </div>
        <div className="flex flex-col gap-4 pt-6">
          {alternative ? <span>{alternative}</span> : null}
          <button
            onClick={onContact}
            style={{ minWidth: "250px" }}
            className="cursor-pointer rounded-full bg-primary flex justify-center items-center gap-2 py-3"
          >
            <span className="w-6 h-6 flex justify-center items-center">
              <Whatsapp />
            </span>

            <span className="uppercase text-white font-medium text-base">
              talk to us
            </span>
          </button>
        </div>
      </div>
    </div>
  );
};
